(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bunk-bundles"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  /* ── window.BunkCart — ONE shared engine (Horizon-aware; guarded; identical in every BUNK section) ── */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0);
            });
            var bub = document.querySelector('.cart-bubble');
            if (bub) {
              bub.classList.toggle('visually-hidden', cart.item_count === 0);
              var bc = bub.querySelector('.cart-bubble__text-count');
              if (bc) { bc.textContent = cart.item_count; bc.classList.toggle('hidden', cart.item_count === 0); }
            }
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          }).catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) { t = document.createElement('div'); t.id = 'bunk-cart-toast'; t.setAttribute('role','status'); t.setAttribute('aria-live','polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t); }
        t.textContent = msg; requestAnimationFrame(function () { t.style.opacity='1'; t.style.transform='translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT); window.__bunkToastT = setTimeout(function () { t.style.opacity='0'; t.style.transform='translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } } }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }
            else if ('open' in d) { d.open = true; }
            else { d.classList.add('is-open','active','open','drawer--active'); d.setAttribute('aria-hidden','false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      /* D52 SETS (17 Jul): a SET is several products, so it adds SEVERAL variants in ONE
         /cart/add.js call (Sid: "a set = its component variant IDs added together").
         `variantId` accepts a single id OR a comma-separated list ("123,456").
         NO DEAD BUTTONS (his rule): with no ids at all we open the PDP rather than
         toast a developer message at a customer — which is what shipped before tonight. */
      /* ── SET SLIDESHOW (17 Jul) ────────────────────────────────────────────
         Mirrors the mood-card engine exactly (bunk-moods.liquid): crossfade with the
         outgoing slide held opaque BENEATH the incoming one, so it dissolves and never
         dips to black (Sid, 10 Jul: "theres a flash it hurts the eyes"). Dots are
         tappable. Auto-advance pauses on hover/touch and after a manual pick.        */
      function bunkSetShows() {
        var wraps = document.querySelectorAll('[data-bb-show]');
        Array.prototype.forEach.call(wraps, function (wrap) {
          var slides = [].slice.call(wrap.querySelectorAll('.bb-slide'));
          if (slides.length < 2) return;
          var dotWrap = wrap.querySelector('.bb-dots');
          var dots = [];
          if (dotWrap) {
            slides.forEach(function (_, i) {
              var d = document.createElement('span');
              d.className = 'bb-dot' + (i === 0 ? ' bb-dot--on' : '');
              d.style.cursor = 'pointer';
              dotWrap.appendChild(d); dots.push(d);
            });
          }
          var cur = 0, timer = null;
          function setTo(i) {
            i = ((i % slides.length) + slides.length) % slides.length;
            if (i === cur) return;
            var prev = slides[cur];
            slides.forEach(function (s, k) {
              s.classList.remove('bb-slide--prev');
              s.classList.toggle('bb-slide--on', k === i);
              s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
            });
            if (prev && prev !== slides[i]) {
              prev.classList.add('bb-slide--prev');
              clearTimeout(wrap._bbPrevT);
              wrap._bbPrevT = setTimeout(function () { prev.classList.remove('bb-slide--prev'); }, 950);
            }
            dots.forEach(function (d, k) { d.classList.toggle('bb-dot--on', k === i); });
            cur = i;
          }
          function start() { stop(); timer = setInterval(function () { setTo(cur + 1); }, 4200); }
          function stop() { if (timer) { clearInterval(timer); timer = null; } }
          dots.forEach(function (d, k) {
            d.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); stop(); setTo(k); start(); });
          });
          wrap.addEventListener('mouseenter', stop);
          wrap.addEventListener('mouseleave', start);
          /* swipe — the set cards must swipe like every other polaroid */
          var x0 = null;
          wrap.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
          wrap.addEventListener('touchend', function (e) {
            if (x0 === null) return;
            var dx = e.changedTouches[0].clientX - x0;
            if (Math.abs(dx) > 30) setTo(cur + (dx < 0 ? 1 : -1));
            x0 = null; start();
          }, { passive: true });
          start();
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkSetShows); } else { bunkSetShows(); }

      function add(variantId, qty, meta) {
        meta = meta || {};
        var ids = String(variantId == null ? '' : variantId)
          .split(',').map(function (s) { return s.replace(/[^0-9]/g, ''); }).filter(Boolean);
        if (!ids.length) { if (meta.url && /^(https?:\/\/|\/(?!\/))/i.test(meta.url)) { window.location.href = meta.url; return Promise.resolve(); } toast('connect this product in Shopify to enable add-to-baggy'); return Promise.reject(new Error('no variant id')); }
        var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: qty || 1 }; });
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            /* count + toast only — the baggy opens on the baggy tap, never auto (Sid, 2 Jul) */
            /* BUGFIX 18 Jul (Sid: "the baggy counter increases but the cart shows empty") —
               re-render the drawer contents so the added item is present when the baggy is
               next opened. Horizon's cart-items-component self-fetches its own section on
               'cart:update' when no sections payload is present; the drawer has no auto-open
               attribute, so this refreshes the contents WITHOUT opening the drawer. */
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'bunk-cart' } } }));
            return cart;
          })
          .catch(function (err) { toast((err && err.description) ? err.description : 'couldn’t add — check the product'); throw err; });
      }
      function bunkBoot() {
        refresh();
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        document.body.addEventListener('click', function (e) { var bag = e.target.closest && e.target.closest('[data-bunk-bag]'); if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } } });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  var section = document.querySelector('.bunk-bundles');
  if (!section) return;

  /* ── ADD TO BAGGY → real cart ── */
  section.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bag]');
    if (!btn) return;
    e.preventDefault();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1'; btn.classList.add('is-busy');
    window.BunkCart.add(btn.dataset.variantId || '', 1, { name: btn.dataset.bag || '', price: btn.dataset.price || '', url: btn.dataset.productUrl || '' })
      .catch(function () {}).then(function () { btn.dataset.busy = '0'; btn.classList.remove('is-busy'); });
  });

  /* ── referral share ── */
  var ref = section.querySelector('[data-bb-ref]');
  if (ref) {
    ref.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bb-share]'); if (!b) return;
      var mode = b.dataset.bbShare, link = b.dataset.bbLink || window.location.origin;
      if (mode === 'copy') { e.preventDefault(); (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(function () { window.BunkCart.toast('link copied — give 15, get 15'); }).catch(function () { window.prompt('copy your link:', link); }); }
      else if (mode === 'share') { e.preventDefault(); if (navigator.share) { navigator.share({ title: 'BUNK', text: 'give 15, get 15', url: link }).catch(function () {}); } else { (navigator.clipboard ? navigator.clipboard.writeText(link) : Promise.reject()).then(function () { window.BunkCart.toast('link copied'); }).catch(function () { window.prompt('copy your link:', link); }); } }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-bunkers"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var section = document.querySelector('.bunk-bunkers');
  if (!section) return;
  var cards = Array.prototype.slice.call(section.querySelectorAll('[data-bk-card]'));
  var lb = section.querySelector('[data-bk-lb]');
  var stage = section.querySelector('[data-bk-stage]');
  if (!lb || !stage || !cards.length) return;
  var cur = 0;

  function ytEmbed(url){ var m = url && url.match(/(?:youtu\.be\/|v=)([\w-]{11})/); return m ? 'https://www.youtube.com/embed/'+m[1]+'?autoplay=1' : null; }
  /* build lightbox content with DOM nodes (never HTML strings) so review text /
     URLs can't be re-interpreted as markup */
  function mk(tag, cls, text){ var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function mkImg(srcEl){ var im = document.createElement('img'); im.src = srcEl.src; im.alt = ''; return im; }
  function render(i){
    cur = (i + cards.length) % cards.length;
    var c = cards[cur], type = c.dataset.bkType;
    stage.innerHTML = '';
    if (type === 'review_text'){
      var q = c.querySelector('[data-bk-quote]'); var by = c.querySelector('.bk-by');
      stage.appendChild(mk('div', 'bk-lb-quote', q ? q.textContent : ''));
      if (by) stage.appendChild(mk('div', 'bk-lb-by', by.textContent));
    } else if (type === 'review_video'){
      var v = c.querySelector('[data-bk-video]'); var url = v ? v.getAttribute('data-bk-video') : '';
      var emb = ytEmbed(url);
      if (emb){
        var fr = document.createElement('iframe');
        fr.src = emb; fr.setAttribute('allow', 'autoplay; encrypted-media'); fr.setAttribute('allowfullscreen', ''); fr.height = 500;
        stage.appendChild(fr);
      } else if (url && /^https:\/\//i.test(url)){
        var vd = document.createElement('video');
        vd.src = url; vd.controls = true; vd.autoplay = true; vd.setAttribute('playsinline', '');
        stage.appendChild(vd);
      } else {
        var img = c.querySelector('img');
        stage.appendChild(img ? mkImg(img) : mk('div', 'bk-lb-by', 'video coming soon'));
      }
    } else if (type === 'review_image'){
      var im = c.querySelector('img');
      stage.appendChild(im ? mkImg(im) : mk('div', 'bk-lb-by', 'screenshot coming soon'));
    }
  }
  function open(i){ render(i); lb.hidden = false; lb.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; }
  function close(){ lb.hidden = true; lb.setAttribute('aria-hidden','true'); stage.innerHTML=''; document.documentElement.style.overflow=''; }

  cards.forEach(function(c){
    c.addEventListener('click', function(){ open(parseInt(c.dataset.bkI||'0',10)); });
    c.addEventListener('keydown', function(e){ if (e.key==='Enter'||e.key===' '){ e.preventDefault(); open(parseInt(c.dataset.bkI||'0',10)); } });
  });
  section.querySelector('[data-bk-close]').addEventListener('click', close);
  section.querySelector('[data-bk-prev]').addEventListener('click', function(){ render(cur-1); });
  section.querySelector('[data-bk-next]').addEventListener('click', function(){ render(cur+1); });
  lb.addEventListener('click', function(e){ if (e.target === lb) close(); });
  document.addEventListener('keydown', function(e){ if (lb.hidden) return; if (e.key==='Escape') close(); else if (e.key==='ArrowRight') render(cur+1); else if (e.key==='ArrowLeft') render(cur-1); });
  /* swipe in lightbox */
  var sx=null; lb.addEventListener('touchstart', function(e){ sx=e.touches[0].clientX; }, {passive:true});
  lb.addEventListener('touchend', function(e){ if (sx==null) return; var dx=e.changedTouches[0].clientX-sx; if (Math.abs(dx)>45){ render(dx<0?cur+1:cur-1); } sx=null; });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  // Respect prefers-reduced-motion for any animated interactions
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Club form: soft focus / empty guard (Shopify handles actual submission) ──
  var form = document.getElementById('bunk-club-form');
  if (form) {
    var emailInput = form.querySelector('.bunk-club__input');
    var joinBtn    = form.querySelector('.bunk-club__join');

    // Inline empty guard for instant feedback before Shopify validates
    if (emailInput && joinBtn) {
      form.addEventListener('submit', function(e) {
        var val = emailInput.value.trim();
        if (!val) {
          e.preventDefault();
          emailInput.focus();
          return;
        }
        // Basic RFC-5322 rough check
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
          e.preventDefault();
          emailInput.focus();
          return;
        }
        // Disable button to prevent double-submit
        joinBtn.disabled = true;
        joinBtn.textContent = 'JOINING…';
      });
    }

    // Re-enable on any server error reload
    var errorEl = form.querySelector('.bunk-club__error');
    if (errorEl && joinBtn) {
      joinBtn.disabled = false;
      joinBtn.textContent = 'JOIN';
    }
  }

  // ── Stamp hover tilt: subtle ink-stamp jitter on the lockup stamp ──
  if (!reducedMotion) {
    var stampWrap = document.querySelector('.bunk-footer__stamp-wrap');
    if (stampWrap) {
      stampWrap.addEventListener('mouseenter', function() {
        var jitter = (Math.random() * 2 - 1).toFixed(1);
        stampWrap.style.transform = 'none';
      });
      stampWrap.addEventListener('mouseleave', function() {
        stampWrap.style.transform = 'none';
      });
    }
  }

  // ── Club stamp hover (the smaller one in the "join the BUNK club" head) ──
  if (!reducedMotion) {
    var clubStampWrap = document.querySelector('.bunk-club__stamp-wrap');
    if (clubStampWrap) {
      clubStampWrap.addEventListener('mouseenter', function() {
        var j = (Math.random() * 2 - 1).toFixed(1);
        clubStampWrap.style.transform = 'rotate(' + (parseFloat(-5) + parseFloat(j)) + 'deg)';
      });
      clubStampWrap.addEventListener('mouseleave', function() {
        clubStampWrap.style.transform = 'rotate(-5deg)';
      });
    }
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-format"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ================================================================
     window.BunkCart — ONE shared add-to-cart engine for the whole site.
     Defined once (guarded); every BUNK section reuses it. No external
     asset to forget, no snippet to miss — it can't break the build.
     ADD TO BAGGY === add to the Shopify cart (POST /cart/add.js).
     ================================================================ */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
            var bub = document.querySelector('.cart-bubble');
            if (bub) {
              bub.classList.toggle('visually-hidden', cart.item_count === 0);
              var bc = bub.querySelector('.cart-bubble__text-count');
              if (bc) { bc.textContent = cart.item_count; bc.classList.toggle('hidden', cart.item_count === 0); }
            }
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bunk-cart-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t);
        }
        t.textContent = msg;
        requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT);
        window.__bunkToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        /* Horizon 2025 (3.0+): the theme listens for `cart:update` → it
           refreshes its own cart count AND opens its drawer. Harmless on
           themes that don't listen. THIS is the line that makes Horizon work. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } }
        }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        /* Also drive the drawer element directly, across theme families. */
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }          /* Dawn-family: open() is a method */
            else if ('open' in d) { d.open = true; }                 /* Horizon: open is a boolean property */
            else { d.classList.add('is-open', 'active', 'open', 'drawer--active'); d.setAttribute('aria-hidden', 'false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      function add(variantId, qty, meta) {
        meta = meta || {};
        variantId = (variantId == null ? '' : String(variantId)).replace(/[^0-9]/g, '');
        if (!variantId) {
          /* No variant wired yet → never a dead button: go to the product page. */
          if (meta.url && /^(https?:\/\/|\/(?!\/))/i.test(meta.url)) { window.location.href = meta.url; return Promise.resolve(); }
          toast('connect this product in Shopify to enable add-to-baggy');
          return Promise.reject(new Error('no variant id'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            /* count + toast only — the baggy opens on the baggy tap, never auto (Sid, 2 Jul) */
            /* BUGFIX 18 Jul (Sid: "the baggy counter increases but the cart shows empty") —
               re-render the drawer contents so the added item is present when the baggy is
               next opened. Horizon's cart-items-component self-fetches its own section on
               'cart:update' when no sections payload is present; the drawer has no auto-open
               attribute, so this refreshes the contents WITHOUT opening the drawer. */
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'bunk-cart' } } }));
            return cart;
          })
          .catch(function (err) {
            toast((err && err.description) ? err.description : 'couldn’t add — check the product');
            throw err;
          });
      }
      function bunkBoot() {
        refresh();
        /* paper-grain overlay — auto-add if the theme didn't (styled by bunk-foundation.css .bunk-grain). Existence-checked = no doubling. */
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        /* any "your baggy" pill opens the cart */
        document.body.addEventListener('click', function (e) {
          var bag = e.target.closest && e.target.closest('[data-bunk-bag]');
          if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } }
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  var SLIDE_INTERVAL = 5000;   /* Sid 25 Jul: one shared clock with the hero (was 4000) */
  var TOAST_DURATION = 1700;
  var toastTimer = null;
  var slideTimers = {};

  /* ── helpers ── */
  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── ACCORDION — DELEGATED (bind once). Tap the SEE MORE tape OR the polaroid
        card to expand; one open at a time; CSS drives the reveal via .open. ── */
  function initAccordion(section) {
    if (window.__bunkFmtAcc) return;          /* delegated once on document */
    window.__bunkFmtAcc = true;
    document.addEventListener('click', function (e) {
      if (Date.now() < (window._bunkSwipeUntil || 0)) return;   /* a photo swipe just happened — don't toggle */
      var card = e.target.closest('.bunk-format__card');
      if (!card) return;
      /* never act when the real add-to-baggy chip / link is what was clicked */
      if (e.target.closest('[data-add-to-baggy], .bunk-format__chip, a, .bunk-format__dots')) return;
      var toggle = e.target.closest('[data-card-toggle]');

      /* HYBRID (Sid 27 Jun): tap the SEE MORE tape → expand; tap the photo/card → go to the product page */
      if (!toggle) {
        if (e.target.closest('.bunk-format__ladder')) return;   /* clicks inside an open ladder do nothing */
        var purl = card.getAttribute('data-card-url');
        if (purl) { window.location.href = purl; return; }      /* photo/card → PDP */
        /* no url set → fall through to expand so the tap is never dead */
      }

      var isOpen = card.classList.contains('open');
      /* close the others */
      document.querySelectorAll('.bunk-format__card.open').forEach(function (c) {
        if (c === card) return;
        c.classList.remove('open');
        var b = c.querySelector('[data-card-toggle]'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      card.classList.toggle('open', !isOpen);
      var tb = card.querySelector('[data-card-toggle]');
      if (tb) tb.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    }, false);
  }

  /* ── ADD TO BAGGY → real Shopify cart (/cart/add.js via window.BunkCart) ── */
  /* D75 (Sid: card→PDP "a bit slow"): prefetch the product page the moment a card is hovered,
     so the click lands on a warm cache. One <link rel=prefetch> per URL, ever. */
  function initPrefetch(section) {
    var seen = {};
    section.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest('.bunk-format__card');
      if (!card) return;
      var url = card.getAttribute('data-card-url');
      if (!url || seen[url]) return;
      seen[url] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch'; l.href = url; l.as = 'document';
      document.head.appendChild(l);
    });
  }

  function initAddToBaggy(section) {
    section.querySelectorAll('[data-add-to-baggy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var chip = btn.closest('.bunk-format__chip');
        if (!chip) return;
        var mood   = chip.dataset.mood   || '';
        var price  = chip.dataset.price  || '';
        var format = chip.dataset.format || '';
        var vid    = chip.dataset.variantId || '';
        var url    = chip.dataset.productUrl || chip.getAttribute('href') || '';

        if (btn.dataset.busy === '1') return;
        btn.dataset.busy = '1';
        btn.classList.add('is-busy');

        window.BunkCart.add(vid, 1, { name: format + ' · ' + mood, price: price, url: url })
          .catch(function () {})
          .then(function () { btn.dataset.busy = '0'; btn.classList.remove('is-busy'); });
      });
    });
  }

  /* ── CROSSFADE SLIDESHOW — starts at the hero slide when scrolled into view,
        swipeable, and auto-advance resumes from wherever you left off. ── */
  function fmtSlides(card){ return card.querySelectorAll('.bunk-format__slide'); }
  function fmtDots(card, idx){
    card.querySelectorAll('.bunk-format__dot').forEach(function (d, i) { d.classList.toggle('on', i === idx); });
  }
  function fmtSet(card, idx){
    var slides = fmtSlides(card), w = fmtWin(card);
    if (!slides.length || !w) return;
    idx = ((idx % slides.length) + slides.length) % slides.length;
    w.scrollTo({ left: idx * w.clientWidth, behavior: 'smooth' });
    fmtDots(card, idx);
  }
  function fmtWin(card){ return card.querySelector('.bunk-format__track') || card.querySelector('.bunk-format__win'); }
  function fmtCur(card){
    var w = fmtWin(card); if (!w || !w.clientWidth) return 0;
    return Math.round(w.scrollLeft / w.clientWidth);
  }
  function fmtStep(card, dir){ fmtSet(card, fmtCur(card) + (dir || 1)); }

  function initSlideshows(section) {
    section.querySelectorAll('.bunk-format__card').forEach(function (card, i) {
      if (fmtSlides(card).length < 2) return;
      /* Sid 25 Jul: "the swipe does not change the picture". Cause found — init() runs more than
         once (DOM-ready pass + shopify:section:load), and nothing stopped it re-binding, so every
         card carried TWO touchend handlers and one swipe advanced TWO slides. On a 4-photo loop
         two swipes land you back on the first photo, which reads as "nothing happened".
         Bind once per card, ever. */
      if (card._fmtBound) return;
      card._fmtBound = true;
      /* dots follow a manual drag/scroll as well as an auto advance */
      (function(){
        var w = card.querySelector('.bunk-format__track') || card.querySelector('.bunk-format__win'); if (!w) return;
        var t; w.addEventListener('scroll', function(){
          clearTimeout(t);
          t = setTimeout(function(){ fmtDots(card, fmtCur(card)); }, 90);
        }, { passive: true });
      })();
      var win = card.querySelector('.bunk-format__win') || card;
      /* Sid 25 Jul: one shared clock with the hero. The per-card stagger stays, but as PHASE, not
         speed (Fable) — the FIRST advance is offset by i*400ms, every interval after it is a flat
         SLIDE_INTERVAL. Cards ripple instead of blinking together, and never drift apart over time. */
      function startAuto(){
        if (card._fmtTimer || card._fmtKick || reduceMotion()) return;
        card._fmtKick = setTimeout(function () {
          card._fmtKick = null;
          fmtStep(card, 1);
          card._fmtTimer = setInterval(function () { fmtStep(card, 1); }, SLIDE_INTERVAL);
        }, SLIDE_INTERVAL + i * 400);
      }
      function stopAuto(){
        if (card._fmtKick)  { clearTimeout(card._fmtKick);   card._fmtKick  = null; }
        if (card._fmtTimer) { clearInterval(card._fmtTimer); card._fmtTimer = null; }
      }
      /* start at the hero the FIRST time the card enters view; play in view, pause out of view */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { if (!card._fmtSeen) { fmtSet(card, 0); card._fmtSeen = true; } startAuto(); }
            else { stopAuto(); }
          });
        }, { threshold: 0 }).observe(card);   /* 0 so tall cards (taller than viewport) still trigger */
      } else { startAuto(); }
      /* swipe through the photos, then auto resumes from where you left off */
      var x0 = null, y0 = null;
      win.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      win.addEventListener('touchend', function (e) {
        if (x0 == null) return; var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { window._bunkSwipeUntil = Date.now() + 400; stopAuto(); fmtStep(card, dx < 0 ? 1 : -1); startAuto(); }
        x0 = y0 = null;
      }, { passive: true });
      /* ── Sid 25 Jul, 8th report of "I can't swipe": the handler above is TOUCH-ONLY, and he
            tests in a desktop preview window with a mouse, which fires no touch events at all.
            The hero already had mouse drag; format and moods never did. Same pattern here. ── */
      var mDown = null, mDragging = false;
      win.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mDown = e.clientX; mDragging = false;
      });
      win.addEventListener('mousemove', function (e) {
        if (mDown === null) return;
        if (Math.abs(e.clientX - mDown) > 6) { mDragging = true; e.preventDefault(); }
      });
      window.addEventListener('mouseup', function (e) {
        if (mDown === null) return;
        var dx = e.clientX - mDown;
        if (mDragging && Math.abs(dx) > 40) {
          window._bunkSwipeUntil = Date.now() + 400;
          stopAuto(); fmtStep(card, dx < 0 ? 1 : -1); startAuto();
        }
        mDown = null;
        if (mDragging) {
          win.addEventListener('click', function swallow(ev){ ev.stopPropagation(); ev.preventDefault(); win.removeEventListener('click', swallow, true); }, true);
        }
        mDragging = false;
      });
      win.style.cursor = 'grab';
      win.addEventListener('mousedown', function(){ win.style.cursor='grabbing'; });
      window.addEventListener('mouseup', function(){ win.style.cursor='grab'; });

      /* dots are tappable too */
      card.querySelectorAll('.bunk-format__dot').forEach(function (d, di) { d.style.cursor = 'pointer'; d.addEventListener('click', function (ev) { ev.stopPropagation(); stopAuto(); fmtSet(card, di); startAuto(); }); });
    });
  }

  /* ── INIT ── */
  function init(section) {
    initAccordion(section);
    initAddToBaggy(section);
    initSlideshows(section);
    initPrefetch(section);
  }

  /* Shopify theme editor: re-init when section is reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = document.getElementById('bunk-format-' + e.detail.sectionId);
    if (sec) init(sec);
  });

  /* On DOM ready */
  document.querySelectorAll('.bunk-format').forEach(function (sec) {
    init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const AUTOPLAY_INTERVAL = 5000; // ms — hero_timing=A (Sid pick): 5s per slide
  const TRANSITION_MS = 480;      // D73: faster change (must match CSS)
  const RESUME_DELAY = 8000;      // hero_timing=A: autoplay resumes 8s after you stop interacting

  function initHero(section) {
    const slides   = Array.from(section.querySelectorAll('[data-slide]'));
    const dots     = Array.from(section.querySelectorAll('[data-dot]'));
    const pauseBtn = section.querySelector('[data-pause-btn]');
    const win      = section.querySelector('[data-slideshow]');

    if (!slides.length) return;

    let current   = 0;
    let timer     = null;
    let paused    = false;
    let isTransit = false; // guard rapid taps

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ── FAN-5: the 4 fan seats (desktop ≥1024) — prev2/prev/next/next2 previews in sync ──
    var photoWrap = section.querySelector('.bunk-hero__photo-wrap');
    var fanSeats = [
      { img: section.querySelector('[data-hero-ghost="prev2"] img'), btn: section.querySelector('[data-hero-ghost="prev2"]'), off: -2 },
      { img: section.querySelector('[data-hero-ghost="prev"] img'),  btn: section.querySelector('[data-hero-ghost="prev"]'),  off: -1 },
      { img: section.querySelector('[data-hero-ghost="next"] img'),  btn: section.querySelector('[data-hero-ghost="next"]'),  off: 1 },
      { img: section.querySelector('[data-hero-ghost="next2"] img'), btn: section.querySelector('[data-hero-ghost="next2"]'), off: 2 }
    ];
    /* < 5 slides → no distinct print for the outer seats: hide them, fall back to the 3-card hand */
    if (slides.length < 5) fanSeats.forEach(function (s) { if (Math.abs(s.off) === 2 && s.btn) s.btn.style.display = 'none'; });
    function syncFan() {
      if (slides.length < 2) return;
      fanSeats.forEach(function (seat) {
        if (!seat.img) return;
        if (Math.abs(seat.off) === 2 && slides.length < 5) return;
        var idx = ((current + seat.off) % slides.length + slides.length) % slides.length;
        var si = slides[idx].querySelector('img');
        if (!si) return;
        var want = si.currentSrc || si.getAttribute('src');
        if (want && seat.img.getAttribute('src') !== want) seat.img.src = want;
      });
    }
    var syncGhosts = syncFan; /* old name still referenced below — same engine */

    // ── core: go to slide N ────────────────────────────────────
    function goTo(n, fromAuto) {
      if (isTransit && !fromAuto) return;
      if (n === current) return;

      isTransit = true;

      /* is-prev layering (Sid 11 Jul): the outgoing slide holds fully opaque BENEATH while
         the incoming fades in ON TOP — a seamless dissolve, never a dip through black. */
      var prev = slides[current];
      slides.forEach(function (s) { if (s !== prev) s.classList.remove('is-prev'); });
      prev.classList.remove('is-on');
      prev.classList.add('is-prev');
      prev.setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('is-on');
        dots[current].setAttribute('aria-selected', 'false');
      }

      current = (n + slides.length) % slides.length;

      slides[current].classList.remove('is-prev');
      slides[current].classList.add('is-on');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('is-on');
        dots[current].setAttribute('aria-selected', 'true');
      }

      setTimeout(function () {
        isTransit = false;
        prev.classList.remove('is-prev');
        /* D75 settle (Sid: "it jerks"): freeze ghost transitions for one frame while the deal class
           drops and the seats resync — the promoted card lands in its new seat with zero visible
           backwards travel; transitions re-enable on the next frame. */
        if (photoWrap) {
          photoWrap.classList.add('is-settling');
          photoWrap.classList.remove('is-deal-next', 'is-deal-prev');
          syncFan();
          requestAnimationFrame(function () { requestAnimationFrame(function () {
            photoWrap.classList.remove('is-settling');
          }); });
        } else { syncFan(); }
      }, prefersReduced ? 0 : TRANSITION_MS);
    }

    /* FAN-5: the deal wrapper — +1/-1 moves get the dealt-card choreography; dots stay plain */
    function deal(dir, fromAuto) {
      if (isTransit && !fromAuto) return;
      if (photoWrap && !prefersReduced) photoWrap.classList.add(dir > 0 ? 'is-deal-next' : 'is-deal-prev');
      goTo(current + dir, fromAuto);
    }

    // ── tap a peeking card → deal it to the front (desktop) ──
    var FAN_STEP = { prev2: -2, prev: -1, next: 1, next2: 2 };
    Array.prototype.forEach.call(section.querySelectorAll('[data-hero-ghost]'), function (g) {
      g.addEventListener('click', function () {
        var step = FAN_STEP[g.getAttribute('data-hero-ghost')] || 1;
        /* outer tap = one clean long deal in that direction (spec: no double-shuffle) */
        if (isTransit) return;
        if (photoWrap && !prefersReduced) photoWrap.classList.add(step > 0 ? 'is-deal-next' : 'is-deal-prev');
        goTo(current + step, false);
        if (!paused) scheduleResume();
      });
    });
    syncFan();

    // ── autoplay ───────────────────────────────────────────────
    var resumeTimer = null;
    function start() {
      if (prefersReduced || slides.length < 2) return;
      stop();
      timer = setInterval(function () {
        deal(1, true);
      }, AUTOPLAY_INTERVAL);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
      clearTimeout(resumeTimer);
      resumeTimer = null;
    }
    /* hero_timing=A (Sid pick): after any manual move, hold, then resume autoplay 8s later.
       Every manual move already advances to a NEW slide via goTo and never snaps back. */
    function scheduleResume() {
      if (prefersReduced || paused) return;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { start(); }, RESUME_DELAY);
    }

    // ── pause toggle ───────────────────────────────────────────
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        if (paused) { stop(); } else { start(); }
      });
    }

    // ── dot nav ────────────────────────────────────────────────
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var n = parseInt(dot.getAttribute('data-dot'), 10);
        goTo(n, false);
        if (!paused) { scheduleResume(); } // hold, resume autoplay 8s after
      });
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { deal(-1, false); scheduleResume(); }
        if (e.key === 'ArrowRight') { deal(1, false); scheduleResume(); }
      });
    });

    // ── swipe / touch ─────────────────────────────────────────
    if (win) {
      var xStart = null;
      win.addEventListener('touchstart', function (e) {
        xStart = e.touches[0].clientX;
      }, { passive: true });
      win.addEventListener('touchend', function (e) {
        if (xStart === null) return;
        var dx = e.changedTouches[0].clientX - xStart;
        if (Math.abs(dx) > 40) {
          deal(dx < 0 ? 1 : -1, false);
          if (!paused) scheduleResume();
        }
        xStart = null;
      }, { passive: true });

      /* ── desktop MOUSE drag-to-swipe (hero_timing=A: Fable found this was unwired,
            touch-only). Drag > 40px = a NEW slide; small drags fall through as clicks. ── */
      var mDown = null, mDragging = false;
      win.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mDown = e.clientX; mDragging = false;
      });
      win.addEventListener('mousemove', function (e) {
        if (mDown === null) return;
        if (Math.abs(e.clientX - mDown) > 6) { mDragging = true; e.preventDefault(); }
      });
      window.addEventListener('mouseup', function (e) {
        if (mDown === null) return;
        var dx = e.clientX - mDown;
        if (mDragging && Math.abs(dx) > 40) {
          deal(dx < 0 ? 1 : -1, false);
          if (!paused) scheduleResume();
        }
        mDown = null;
        /* swallow the click that follows a real drag so it doesn't also fire a ghost/card tap */
        if (mDragging) {
          win.addEventListener('click', function swallow(ev) { ev.stopPropagation(); ev.preventDefault(); win.removeEventListener('click', swallow, true); }, true);
        }
        mDragging = false;
      });

      /* D73 (Sid 24 Jul): TRACKPAD two-finger swipe changes the picture — horizontal wheel intent
         only (|deltaX| > |deltaY|), accumulated past a threshold, one deal per gesture. */
      var wheelAcc = 0, wheelLock = false;
      win.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; /* vertical scroll passes through */
        e.preventDefault();
        if (wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) > 60) {
          wheelLock = true;
          deal(wheelAcc > 0 ? 1 : -1, false);
          if (!paused) scheduleResume();
          wheelAcc = 0;
          setTimeout(function () { wheelLock = false; }, 560);
        }
      }, { passive: false });
    }

    // ── keyboard on win ───────────────────────────────────────
    if (win) {
      win.setAttribute('tabindex', '0');
      win.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { deal(-1, false); if (!paused) scheduleResume(); }
        if (e.key === 'ArrowRight') { deal(1, false); if (!paused) scheduleResume(); }
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          pauseBtn && pauseBtn.click();
        }
      });
    }

    // ── pause on hover (desktop) ──────────────────────────────
    if (win) {
      win.addEventListener('mouseenter', stop);
      win.addEventListener('mouseleave', function () { if (!paused) start(); });
    }

    // ── init ──────────────────────────────────────────────────
    start();
  }

  /* ── ticker=A loop fix (Sid: "ticker goes empty, that cant happen") ──
     The gap was a code bug, not a copy shortage: the strip was duplicated only
     twice, so on wide screens one copy was narrower than the viewport and a gap
     scrolled through. Fix = build ONE group wide enough to cover the container
     (repeat the base line as many times as needed), then render it TWICE so the
     -50% keyframe always lands on an identical group. No gap at any width. */
  function buildTicker(inner) {
    var tick = inner.closest('.bunk-hero__tick');
    if (!tick) return;
    var base = (inner.getAttribute('data-ticker-base') || inner.textContent || '').replace(/\s+/g, ' ').trim();
    if (!base) return;
    inner.setAttribute('data-ticker-base', base);
    /* container width can read 0 in some preview/iframe states → floor at 1600px so the
       group is always wider than any desktop viewport and the loop never opens a gap. */
    var cw = Math.max(
      tick.getBoundingClientRect().width || 0,
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0,
      1600
    );
    inner.textContent = base + ' ';
    var unitW = inner.scrollWidth || 1;
    var reps = Math.max(2, Math.ceil((cw * 1.2) / unitW));    // one group ≥ ~1.2× the viewport
    var group = '';
    for (var i = 0; i < reps; i++) group += base + '  ';
    inner.textContent = group + group;                        // [group][group] → seamless -50% loop
  }
  function initTickers() {
    document.querySelectorAll('[data-ticker-inner]').forEach(buildTicker);
  }
  var __tkT;
  window.addEventListener('resize', function () {
    clearTimeout(__tkT);
    __tkT = setTimeout(initTickers, 200);
  });

  // ── boot (section may render in Theme Editor via "on:section:load") ──
  function boot() {
    document.querySelectorAll('.bunk-hero').forEach(initHero);
    initTickers();
  }
  document.addEventListener('DOMContentLoaded', boot);

  // Shopify Theme Editor live-reload
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('.bunk-hero');
    if (s) initHero(s);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    // timers auto-collected when section is removed from DOM
  });

}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-lab-reports"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  var section = document.querySelector('[id^="bunk-"]');
  if (!section) return;
  var gate = section.querySelector('[data-lab-gate]');
  var body = section.querySelector('[data-lab-body]');
  var KEY = 'bunk_lab_ok';
  function reveal(){ if (gate) gate.style.display = 'none'; if (body) body.hidden = false; }
  try { if (sessionStorage.getItem(KEY) === '1') reveal(); } catch(e){}
  var yes = section.querySelector('[data-lab-enter]');
  if (yes) yes.addEventListener('click', function(){ try { sessionStorage.setItem(KEY,'1'); } catch(e){} reveal(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-moods"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  /* ================================================================
     window.BunkCart — ONE shared add-to-cart engine (defined once,
     guarded; identical in every BUNK section). ADD TO BAGGY === add
     to the Shopify cart (POST /cart/add.js). No external asset/snippet.
     ================================================================ */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
            var bub = document.querySelector('.cart-bubble');
            if (bub) {
              bub.classList.toggle('visually-hidden', cart.item_count === 0);
              var bc = bub.querySelector('.cart-bubble__text-count');
              if (bc) { bc.textContent = cart.item_count; bc.classList.toggle('hidden', cart.item_count === 0); }
            }
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bunk-cart-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t);
        }
        t.textContent = msg;
        requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT);
        window.__bunkToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        /* Horizon 2025 (3.0+): the theme listens for `cart:update` → it
           refreshes its own cart count AND opens its drawer. Harmless on
           themes that don't listen. THIS is the line that makes Horizon work. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } }
        }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        /* Also drive the drawer element directly, across theme families. */
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }          /* Dawn-family: open() is a method */
            else if ('open' in d) { d.open = true; }                 /* Horizon: open is a boolean property */
            else { d.classList.add('is-open', 'active', 'open', 'drawer--active'); d.setAttribute('aria-hidden', 'false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      function add(variantId, qty, meta) {
        meta = meta || {};
        variantId = (variantId == null ? '' : String(variantId)).replace(/[^0-9]/g, '');
        if (!variantId) {
          if (meta.url && /^(https?:\/\/|\/(?!\/))/i.test(meta.url)) { window.location.href = meta.url; return Promise.resolve(); }
          toast('connect this product in Shopify to enable add-to-baggy');
          return Promise.reject(new Error('no variant id'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            /* count + toast only — the baggy opens on the baggy tap, never auto (Sid, 2 Jul) */
            /* BUGFIX 18 Jul (Sid: "the baggy counter increases but the cart shows empty") —
               re-render the drawer contents so the added item is present when the baggy is
               next opened. Horizon's cart-items-component self-fetches its own section on
               'cart:update' when no sections payload is present; the drawer has no auto-open
               attribute, so this refreshes the contents WITHOUT opening the drawer. */
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'bunk-cart' } } }));
            return cart;
          })
          .catch(function (err) {
            toast((err && err.description) ? err.description : 'couldn’t add — check the product');
            throw err;
          });
      }
      function bunkBoot() {
        refresh();
        /* paper-grain overlay — auto-add if the theme didn't (styled by bunk-foundation.css .bunk-grain). Existence-checked = no doubling. */
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        document.body.addEventListener('click', function (e) {
          var bag = e.target.closest && e.target.closest('[data-bunk-bag]');
          if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } }
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  var section = document.querySelector('.bunk-moods');
  if (!section) return;

  /* ---- PREFFERS REDUCED MOTION ---- */
  var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- ACCORDION: tap mood card → toggle ladder ---- */
  var moods = section.querySelectorAll('.bm-mood');

  function openMood(el) {
    var ladder  = el.querySelector('.bm-ladder');
    var shopBtn = el.querySelector('[data-mood-toggle]');
    if (!ladder) return;
    var isOpen = el.classList.contains('is-open');

    // close all others first
    moods.forEach(function(m) {
      if (m !== el && m.classList.contains('is-open')) {
        closeMood(m);
      }
    });

    if (isOpen) {
      closeMood(el);
    } else {
      el.classList.add('is-open');
      ladder.removeAttribute('hidden');
      ladder.classList.add('is-open');
      if (shopBtn) shopBtn.setAttribute('aria-expanded', 'true');
    }
  }

  function closeMood(el) {
    var ladder  = el.querySelector('.bm-ladder');
    var shopBtn = el.querySelector('[data-mood-toggle]');
    el.classList.remove('is-open');
    if (ladder) {
      ladder.classList.remove('is-open');
      // wait for CSS transition before hiding from AT
      var delay = prefersReduced ? 0 : 340;
      setTimeout(function(){ if (!ladder.classList.contains('is-open')) ladder.setAttribute('hidden', ''); }, delay);
    }
    if (shopBtn) shopBtn.setAttribute('aria-expanded', 'false');
  }

  moods.forEach(function(mood) {
    // click on card (but not on chip buttons — those stopPropagation)
    mood.addEventListener('click', function(e) {
      if (Date.now() < (window._bunkSwipeUntil || 0)) return;   // a photo swipe just happened — don't toggle
      // if click came from inside .bm-chip, ignore
      if (e.target.closest && e.target.closest('.bm-chip')) return;
      openMood(mood);
    });
    // keyboard: Enter / Space
    mood.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.target.closest && e.target.closest('.bm-chip')) return;
        e.preventDefault();
        openMood(mood);
      }
    });
    // make focusable if not already
    if (!mood.hasAttribute('tabindex')) mood.setAttribute('tabindex', '0');
    mood.setAttribute('role', 'button');
  });

  /* ---- SLIDESHOW + DOTS + ROTATING PRODUCT-FACT MARKER ---- */
  moods.forEach(function(mood) {
    var slides  = mood.querySelectorAll('.bm-slide');
    var dotsWrap= mood.querySelector('.bm-dots');
    var factEl  = mood.querySelector('.bm-fact');

    if (!slides.length) return;
    /* Sid 25 Jul: same re-bind guard as the format cards — if this ever runs twice the swipe
       handler stacks and one swipe advances two photos, which reads as "nothing happened". */
    if (mood._bmBound) return;
    mood._bmBound = true;
    /* Sid 25 Jul: split the mood sentence into a handwritten HOOK + Space Mono detail lines,
       and bold the words that carry the promise ("manage creative block", "focus", "flow"...).
       Done here rather than in Liquid so the copy in the theme editor stays plain text. */
    (function(){
      var el = mood.querySelector('.bm-fact');
      if (!el || el.dataset.bmTiered) return;
      var raw = (el.textContent || '').trim();
      if (!raw) return;
      var KEYS = ['manage creative block','mental restlessness','social anxiety','log off on time',
                  'sharpens focus','locks you in','frees the flow','present in the moment',
                  'out of your own head','work stays at the desk','the evening gets quiet',
                  'with intention','focus','flow'];
      function bold(t){
        KEYS.forEach(function(k){
          var i = t.toLowerCase().indexOf(k);
          if (i > -1 && t.indexOf('<strong>') === -1) {
            t = t.slice(0,i) + '<strong>' + t.slice(i, i+k.length) + '</strong>' + t.slice(i+k.length);
          }
        });
        return t;
      }
      /* Sid 25 Jul: "remove formulated to help from all the moods polaroids, keep the rest of
         the line as the title, just as the above section" — the by-format cards open with the
         promise itself, not a preamble. Strip the lead-in, keep the claim. */
      raw = raw.replace(/^formulated to help you\s+/i, '')
               .replace(/^formulated to help\s+/i, '');
      var parts = raw.split('·').map(function(p){ return p.trim(); }).filter(Boolean);
      if (parts.length < 2) return;
      /* Sid 26 Jul: "the first line doesn't look like the heading, we have to increase the font"
         plus the drop-cap pattern he specified — F small / C big / B big, then M-S-A, then L-O-T.
         A leading ^ in the copy marks the letter that goes big, so the theme-editor text stays
         plain and he can move the emphasis later without touching code. */
      function caps(t){
        return t.replace(/\^(.)/g, '<span class="bm-fact__cap">$1</span>');
      }
      var html = '<span class="bm-fact__hook">' + caps(parts[0]) + '</span>';
      parts.slice(1).forEach(function(p){ html += '<span class="bm-fact__line">' + bold(p.replace(/\^/g,'')) + '</span>'; });
      el.innerHTML = html;
      el.dataset.bmTiered = '1';
    })();
    /* dots follow a manual drag/scroll too */
    (function(){
      var w = mood.querySelector('.bm-track') || mood.querySelector('.bm-win'); if (!w) return;
      var t; w.addEventListener('scroll', function(){
        clearTimeout(t);
        t = setTimeout(function(){
          var i = w.clientWidth ? Math.round(w.scrollLeft / w.clientWidth) : 0;
          current = i;
          mood.querySelectorAll('.bm-dot').forEach(function(d,j){ d.classList.toggle('bm-dot--on', j===i); });
        }, 90);
      }, { passive: true });
    })();

    // build dot nodes
    slides.forEach(function(_, i) {
      var d = document.createElement('span');
      d.className = 'bm-dot' + (i === 0 ? ' bm-dot--on' : '');
      d.setAttribute('aria-hidden', 'true');
      if (dotsWrap) dotsWrap.appendChild(d);
    });

    var dots  = dotsWrap ? dotsWrap.querySelectorAll('.bm-dot') : [];
    var facts = [];
    try { facts = JSON.parse(mood.dataset.facts || '[]'); } catch(e){}
    var current = 0;

    function setTo(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      /* Sid 25 Jul: the strip scrolls now (story mechanism) instead of crossfading in script */
      var w = mood.querySelector('.bm-track') || (slides[0] ? slides[0].parentNode : null);
      if (w && w.clientWidth) w.scrollTo({ left: idx * w.clientWidth, behavior: 'smooth' });
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === idx ? 'false' : 'true'); });
      dots.forEach(function (d, i) { d.classList.toggle('bm-dot--on', i === idx); });
      /* D75 (Sid 25 Jul): the card TEXT stays constant (his manage-line) — only pictures rotate.
         fact stays pinned to fact1; the facts_json rotation is retired. */
      current = idx;
    }
    function step() { setTo(current + 1); }

    if (slides.length > 1) {
      var win = slides[0].parentNode || mood;
      function startAuto() { if (mood._bmTimer || prefersReduced) return; mood._bmTimer = setInterval(step, 5000);   /* Sid 25 Jul: one shared clock with the hero (was 4000) */ }
      function stopAuto() { if (mood._bmTimer) { clearInterval(mood._bmTimer); mood._bmTimer = null; } }
      /* start at the hero the FIRST time it scrolls into view; play in view, pause out */
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { if (!mood._bmSeen) { setTo(0); mood._bmSeen = true; } startAuto(); }
            else { stopAuto(); }
          });
        }, { threshold: 0 }).observe(mood);   /* 0 so tall cards still trigger the slideshow */
      } else { startAuto(); }
      /* swipe through photos; auto resumes from there. Flag suppresses the card tap-to-expand. */
      var x0 = null, y0 = null;
      win.addEventListener('touchstart', function (e) { var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
      win.addEventListener('touchend', function (e) {
        if (x0 == null) return; var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { window._bunkSwipeUntil = Date.now() + 400; stopAuto(); setTo(current + (dx < 0 ? 1 : -1)); startAuto(); }
        x0 = y0 = null;
      }, { passive: true });
      /* ── Sid 25 Jul: mouse drag, same reason as the format cards — the touch handler above
            never fires for someone testing on a desktop with a mouse. ── */
      var mDown = null, mDragging = false;
      win.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        mDown = e.clientX; mDragging = false;
      });
      win.addEventListener('mousemove', function (e) {
        if (mDown === null) return;
        if (Math.abs(e.clientX - mDown) > 6) { mDragging = true; e.preventDefault(); }
      });
      window.addEventListener('mouseup', function (e) {
        if (mDown === null) return;
        var dx = e.clientX - mDown;
        if (mDragging && Math.abs(dx) > 40) {
          window._bunkSwipeUntil = Date.now() + 400;
          stopAuto(); setTo(current + (dx < 0 ? 1 : -1)); startAuto();
        }
        mDown = null;
        if (mDragging) {
          win.addEventListener('click', function swallow(ev){ ev.stopPropagation(); ev.preventDefault(); win.removeEventListener('click', swallow, true); }, true);
        }
        mDragging = false;
      });
      win.style.cursor = 'grab';
      win.addEventListener('mousedown', function(){ win.style.cursor='grabbing'; });
      window.addEventListener('mouseup', function(){ win.style.cursor='grab'; });

      dots.forEach(function (d, di) { d.style.cursor = 'pointer'; d.addEventListener('click', function (ev) { ev.stopPropagation(); stopAuto(); setTo(di); startAuto(); }); });
    }
  });

  /* ---- ADD TO BAGGY → real Shopify cart (/cart/add.js via window.BunkCart) ---- */
  section.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-bag]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.classList.add('is-busy');
    var name = btn.dataset.bag || '';
    var price = btn.dataset.price || '';
    var vid  = btn.dataset.variantId || '';
    var url  = btn.dataset.productUrl || '';
    window.BunkCart.add(vid, 1, { name: name, price: price, url: url })
      .catch(function(){})
      .then(function(){ btn.dataset.busy = '0'; btn.classList.remove('is-busy'); });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-pdp"] && !Shopify.designMode) return;
  try {
    
(function(){
  /* ================================================================
     window.BunkCart — ONE shared add-to-cart engine (defined once,
     guarded; identical in every BUNK section). ADD TO BAGGY === add
     to the Shopify cart (POST /cart/add.js). No external asset/snippet.
     ================================================================ */
  if (!window.BunkCart) {
    window.BunkCart = (function () {
      function refresh() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-bunk-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
            });
            var bub = document.querySelector('.cart-bubble');
            if (bub) {
              bub.classList.toggle('visually-hidden', cart.item_count === 0);
              var bc = bub.querySelector('.cart-bubble__text-count');
              if (bc) { bc.textContent = cart.item_count; bc.classList.toggle('hidden', cart.item_count === 0); }
            }
            document.dispatchEvent(new CustomEvent('bunk:cart:updated', { detail: cart }));
            return cart;
          })
          .catch(function () {});
      }
      function toast(msg) {
        var t = document.getElementById('bunk-cart-toast');
        if (!t) {
          t = document.createElement('div');
          t.id = 'bunk-cart-toast';
          t.setAttribute('role', 'status');
          t.setAttribute('aria-live', 'polite');
          t.style.cssText = 'position:fixed;left:50%;bottom:86px;transform:translateX(-50%) translateY(16px);z-index:120;background:#15120d;color:#FFE100;border:1px solid #5a4d18;padding:10px 16px;border-radius:9px;font-family:"Space Mono",ui-monospace,monospace;font-weight:700;font-size:12px;letter-spacing:.3px;opacity:0;transition:opacity .25s ease,transform .25s ease;pointer-events:none;white-space:nowrap;max-width:90vw;overflow:hidden;text-overflow:ellipsis';
          document.body.appendChild(t);
        }
        t.textContent = msg;
        requestAnimationFrame(function () { t.style.opacity = '1'; t.style.transform = 'translateX(-50%) translateY(0)'; });
        clearTimeout(window.__bunkToastT);
        window.__bunkToastT = setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'translateX(-50%) translateY(16px)'; }, 2300);
      }
      function openCart(itemCount) {
        /* Horizon 2025 (3.0+): the theme listens for `cart:update` → it
           refreshes its own cart count AND opens its drawer. Harmless on
           themes that don't listen. THIS is the line that makes Horizon work. */
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { itemCount: (itemCount == null ? undefined : itemCount), source: 'bunk-cart' } }
        }));
        document.dispatchEvent(new CustomEvent('bunk:cart:open'));
        /* Also drive the drawer element directly, across theme families. */
        var d = document.querySelector('cart-drawer, cart-drawer-component, #CartDrawer, #cart-drawer, .cart-drawer, [data-cart-drawer], .drawer--cart');
        if (d) {
          try {
            if (typeof d.open === 'function') { d.open(); }          /* Dawn-family: open() is a method */
            else if ('open' in d) { d.open = true; }                 /* Horizon: open is a boolean property */
            else { d.classList.add('is-open', 'active', 'open', 'drawer--active'); d.setAttribute('aria-hidden', 'false'); }
            if (typeof d.show === 'function') { d.show(); }
          } catch (e) {}
          return true;
        }
        return false;
      }
      function add(variantId, qty, meta) {
        meta = meta || {};
        variantId = (variantId == null ? '' : String(variantId)).replace(/[^0-9]/g, '');
        if (!variantId) {
          if (meta.url && /^(https?:\/\/|\/(?!\/))/i.test(meta.url)) { window.location.href = meta.url; return Promise.resolve(); }
          toast('connect this product in Shopify to enable add-to-baggy');
          return Promise.reject(new Error('no variant id'));
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        })
          .then(function (r) { if (!r.ok) { return r.json().then(function (e) { throw e; }); } return r.json(); })
          .then(function () { return refresh(); })
          .then(function (cart) {
            toast('added to your baggy' + (meta.name ? (' · ' + meta.name) : '') + (meta.price ? (' · ' + meta.price) : ''));
            /* count + toast only — the baggy opens on the baggy tap, never auto (Sid, 2 Jul) */
            /* BUGFIX 18 Jul (Sid: "the baggy counter increases but the cart shows empty") —
               re-render the drawer contents so the added item is present when the baggy is
               next opened. Horizon's cart-items-component self-fetches its own section on
               'cart:update' when no sections payload is present; the drawer has no auto-open
               attribute, so this refreshes the contents WITHOUT opening the drawer. */
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'bunk-cart' } } }));
            return cart;
          })
          .catch(function (err) {
            toast((err && err.description) ? err.description : 'couldn’t add — check the product');
            throw err;
          });
      }
      function bunkBoot() {
        refresh();
        /* paper-grain overlay — auto-add if the theme didn't (styled by bunk-foundation.css .bunk-grain). Existence-checked = no doubling. */
        if (!document.querySelector('.bunk-grain')) { var g = document.createElement('div'); g.className = 'bunk-grain'; document.body.appendChild(g); }
        document.body.addEventListener('click', function (e) {
          var bag = e.target.closest && e.target.closest('[data-bunk-bag]');
          if (bag) { e.preventDefault(); if (!openCart()) { window.location.href = '/cart'; } }
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bunkBoot); } else { bunkBoot(); }
      return { add: add, refresh: refresh, toast: toast, openCart: openCart };
    })();
  }

  document.querySelectorAll('[data-bunk-pdp]').forEach(function(root){
    var isOil = root.dataset.isOil === 'true';
    var track = root.querySelector('[data-pdp-track]');
    var dots  = root.querySelector('[data-pdp-dots]');
    var thumbs= root.querySelector('[data-pdp-thumbs]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var sbPrice = root.querySelector('[data-pdp-sbprice]');
    var doseEl  = root.querySelector('[data-pdp-dose]');
    var dosetagEl = root.querySelector('[data-pdp-dosetag]');
    var tapeEl  = root.querySelector('[data-pdp-tape]');
    var variantInput = root.querySelector('[data-pdp-variant-id]');
    var sizeBase = null; // base price chosen by size toggle (oil)

    /* per-variant gallery feed (flavour swap) */
    var galleries = {};
    try { var gjEl = root.querySelector('[data-pdp-galleries]'); if(gjEl){ galleries = JSON.parse(gjEl.textContent || '{}'); } } catch(e){ galleries = {}; }

    function escq(s){return (s||'').replace(/[&<>]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;'}[c];});}
    function doseHtml(raw){ // wrap mg between ## markers in red
      if(!raw) return '';
      var parts = raw.split('##');
      var out=''; for(var i=0;i<parts.length;i++){ out += (i%2===1) ? '<span class="bunk-hl">'+escq(parts[i])+'</span>' : escq(parts[i]); }
      /* 26 Jul: the terpenes + ratio suffix is rebuilt here too. It was Liquid-only before, so it
         DISAPPEARED the moment another flavour was tapped. Gummies only. */
      if(!isOil && raw.indexOf('ft.') >= 0){
        out += ' <span class="bunk-pdp__dsuffix"><span class="bunk-pdp__terp">terpenes</span>'
             + ' <span class="bunk-pdp__ratioh">(' + (raw.indexOf('15mg') >= 0 ? '3:1' : '4:1') + ')</span></span>';
      }
      return out;
    }

    /* ── carousel dots ── */
    function buildDots(n){
      if(!dots) return;
      var h=''; for(var i=0;i<n;i++){ h+='<span class="bunk-pdp__gdot'+(i===0?' is-on':'')+'"></span>'; }
      dots.innerHTML=h;
    }
    function syncDots(){
      if(!track) return;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if(dots){ var d=dots.children; for(var k=0;k<d.length;k++){ d[k].classList.toggle('is-on', k===i); } }
      if(thumbs){ var t=thumbs.querySelectorAll('[data-pdp-thumb]'); for(var k=0;k<t.length;k++){ t[k].classList.toggle('is-on', k===i); } }
    }
    if(track){
      buildDots(track.children.length);
      var scT;
      track.addEventListener('scroll', function(){ clearTimeout(scT); scT=setTimeout(syncDots,60); });
    }

    /* ── thumb → scrollTo ── */
    if(thumbs){
      thumbs.addEventListener('click', function(e){
        var btn = e.target.closest('[data-pdp-thumb]'); if(!btn||!track) return;
        var i = parseInt(btn.dataset.pdpThumb||'0',10);
        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        track.scrollTo({left:i*track.clientWidth, behavior: reduce?'auto':'smooth'});
      });
    }

    /* ── mood dots ── */
    function setMood(m){
      root.querySelectorAll('[data-mood]').forEach(function(x){
        if(!x.classList.contains('bunk-pdp__mdot')) return;
        var on = x.dataset.mood === m;
        x.classList.toggle('is-on', on);
        if(on && x.dataset.c){ root.style.setProperty('--ac', x.dataset.c); }
      });
    }

    /* ── variant pick (rebuild from server-rendered metafield data on the pill) ── */
    function pick(btn){
      root.querySelectorAll('[data-pdp-pick]').forEach(function(b){
        var on = b===btn; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on?'true':'false');
      });
      if(variantInput) variantInput.value = btn.dataset.pdpPick;

      var basePrice = sizeBase || btn.dataset.price;
      if(priceEl) priceEl.textContent = basePrice;
      if(sbPrice) sbPrice.textContent = basePrice;
      if(doseEl)  doseEl.innerHTML = doseHtml(btn.dataset.dose);
      if(dosetagEl) dosetagEl.innerHTML = btn.dataset.dosetag ? '<span class="bunk-dtag">'+escq(btn.dataset.dosetag)+'</span>' : '';

      /* D4: psychoactive line follows the dose — verbatim "It is psychoactive in nature" on every variant */
      var psyEl = root.querySelector('[data-pdp-psycho]');
    var ratioEl = root.querySelector('[data-pdp-ratio]');
      if(psyEl){
        if(/15mg/.test(btn.dataset.dose||'')){
          psyEl.className = 'bunk-pdp__psycho is-soft';
          psyEl.innerHTML = '<span class="bunk-pdp__psycho-k">heads up</span> It is psychoactive in nature. The easy way in. 15mg is light on purpose, so you start low and go slow.';
        } else {
          psyEl.className = 'bunk-pdp__psycho';
          psyEl.innerHTML = '<span class="bunk-pdp__psycho-k">heads up</span> It is psychoactive in nature. Not for first-timers.';
        }
      }

      /* Sid 18 Jul: the ingredient declaration follows the dose (15mg ↔ 50mg); oil stays 100%. */
      var ingEl = root.querySelector('[data-pdp-ingredients]');
      if(ingEl){
        if(isOil){   /* 26 Jul: was sniffing the ratio line's "per drop" text, which no longer exists */
          ingEl.textContent = ingEl.getAttribute('data-ingoil') || ingEl.textContent;
        } else {
          ingEl.textContent = /15mg/.test(btn.dataset.dose||'') ? (ingEl.getAttribute('data-ing15')||ingEl.textContent) : (ingEl.getAttribute('data-ing50')||ingEl.textContent);
        }
      }

      var strainEls = root.querySelectorAll('[data-pdp-strain]');
      strainEls.forEach(function(el){ if(btn.dataset.strain) el.textContent = btn.dataset.strain; });

      /* D50a: swap the per-flavour description + light up the matching strain card */
      var fdEl = root.querySelector('[data-pdp-flavdesc]');
      if(fdEl && btn.dataset.desc) fdEl.textContent = btn.dataset.desc;
      if(btn.dataset.card){
        root.querySelectorAll('[data-straincard]').forEach(function(c){
          c.classList.toggle('is-active', c.dataset.straincard === btn.dataset.card);
        });
        /* Sid 18 Jul (Fable): swap the strain-explainer line per strain, in a fixed slot with a crossfade */
        var seEl = root.querySelector('[data-pdp-strainexplain]');
        if(seEl){ seEl.style.display = (btn.dataset.card === 'og') ? 'none' : ''; }
      }

      if(tapeEl){
        /* tape stays OFF-WHITE on all PDPs (Sid 15 Jul) — no longer recolours with the mood */
        tapeEl.style.background = '#EDE4CE';
        tapeEl.style.color = '#2a2318';
      }
      if(btn.dataset.accent) root.style.setProperty('--ac', btn.dataset.accent);
      if(btn.dataset.mood) setMood(btn.dataset.mood);

      rebuildGallery(btn.dataset.pdpPick);
    }

    /* ── per-variant gallery swap: rebuild carousel + thumbs from the JSON feed ── */
    function rebuildGallery(vid){
      if(!track) return;
      var g = galleries && galleries[vid];
      if(!g || !g.length){ if(track) buildDots(track.children.length); syncDots(); return; } // no set → keep current
      var sl='', th='';
      for(var i=0;i<g.length;i++){
        sl += '<div class="bunk-pdp__gslide"><img class="bunk-photo" src="'+g[i].s+'" loading="lazy" alt=""></div>';
        th += '<button type="button" class="bunk-pdp__th'+(i===0?' is-on':'')+'" data-pdp-thumb="'+i+'" aria-label="Photo '+(i+1)+'"><img src="'+g[i].t+'" loading="lazy" alt=""></button>';
      }
      track.innerHTML = sl;
      if(thumbs) thumbs.innerHTML = th;
      track.scrollLeft = 0;
      buildDots(g.length);
      syncDots();
    }
    root.querySelectorAll('[data-pdp-pick]').forEach(function(b){
      b.addEventListener('click', function(){ pick(b); });
    });

    /* mood chip → select its flavour (gummies; the oil block wires its own below) */
    if(!isOil){
      root.querySelectorAll('.bunk-pdp__mdot').forEach(function(dot){
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', function(){
          var target = null;
          root.querySelectorAll('[data-pdp-pick]').forEach(function(b){ if(b.dataset.mood && b.dataset.mood === dot.dataset.mood) target = b; });
          if(target) pick(target);
        });
      });
    }

    /* gallery dots → slide there (tap; thumbs stay the keyboard path) */
    if(dots && track){
      dots.style.pointerEvents = 'auto';
      dots.addEventListener('click', function(e){
        var ds = Array.prototype.slice.call(dots.children), i = ds.indexOf(e.target);
        if(i < 0) return;
        var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
        track.scrollTo({left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth'});
      });
    }

    /* ── OIL: 2 strain pills + size toggle → resolve to the real variant ── */
    if(isOil){
      var oilMatrix = {};
      try { var omEl = root.querySelector('[data-pdp-oilmatrix]'); if(omEl){ oilMatrix = JSON.parse(omEl.textContent || '{}'); } } catch(e){ oilMatrix = {}; }
      var strainBtns = root.querySelectorAll('[data-pdp-strainpick]');
      var sizeBtns   = root.querySelectorAll('[data-pdp-osize]');
      var curStrain = strainBtns[0] ? strainBtns[0].dataset.pdpStrainpick : '';
      var curSize   = sizeBtns[0]   ? sizeBtns[0].dataset.pdpOsize : '';
      function numId(x){ return String(x==null?'':x).replace(/[^0-9]/g,''); }
      function resolveOil(){
        var m = oilMatrix[curStrain + '__' + curSize];
        if(!m) return;
        if(variantInput) variantInput.value = numId(m.id);
        if(priceEl) priceEl.textContent = m.price;
        if(sbPrice) sbPrice.textContent = m.price;
        rebuildGallery(numId(m.id));
      }
      strainBtns.forEach(function(b){
        b.addEventListener('click', function(){
          strainBtns.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-checked','false'); });
          b.classList.add('is-on'); b.setAttribute('aria-checked','true');
          curStrain = b.dataset.pdpStrainpick;
          if(doseEl) doseEl.innerHTML = doseHtml(b.dataset.dose);
          root.querySelectorAll('[data-pdp-strain]').forEach(function(el){ if(b.dataset.strainname) el.textContent = b.dataset.strainname; });
          /* D50a: per-strain description + active card (oil) */
          var ofd = root.querySelector('[data-pdp-flavdesc]');
          if(ofd && b.dataset.desc) ofd.textContent = b.dataset.desc;
          if(b.dataset.card){ root.querySelectorAll('[data-straincard]').forEach(function(c){ c.classList.toggle('is-active', c.dataset.straincard === b.dataset.card); }); }
          if(b.dataset.accent) root.style.setProperty('--ac', b.dataset.accent); /* tape stays gold for oil */
          if(b.dataset.mood) setMood(b.dataset.mood);   /* strain → light its mood dot (Super OG=Disconnect, SLH=Work&Flow) */
          resolveOil();
        });
      });
      sizeBtns.forEach(function(b){
        b.addEventListener('click', function(){
          sizeBtns.forEach(function(x){ x.classList.remove('is-on'); x.setAttribute('aria-checked','false'); });
          b.classList.add('is-on'); b.setAttribute('aria-checked','true');
          curSize = b.dataset.pdpOsize;
          resolveOil();
        });
      });
      /* mood dot → select its strain (the reverse link) so they toggle together */
      root.querySelectorAll('.bunk-pdp__mdot').forEach(function(dot){
        dot.style.cursor = 'pointer';
        dot.addEventListener('click', function(){
          var target = null;
          strainBtns.forEach(function(b){ if(b.dataset.mood && b.dataset.mood === dot.dataset.mood) target = b; });
          if(target){ target.click(); } else { setMood(dot.dataset.mood); }
        });
      });
      resolveOil(); // init variant id + price + gallery
      if(strainBtns[0] && strainBtns[0].dataset.mood) setMood(strainBtns[0].dataset.mood); /* init mood from first strain */
    }

    /* ── add to baggy → real AJAX add via window.BunkCart (native submit fallback) ── */
    var pdpForm = root.querySelector('[data-pdp-form]');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function(e){
        if (!window.BunkCart) return;            // no engine → submit natively to /cart/add
        var idInput = pdpForm.querySelector('[data-pdp-variant-id]');
        var vid = idInput ? idInput.value : '';
        if (!vid) return;                        // no variant → native submit (Shopify handles)
        e.preventDefault();
        var nm = (root.querySelector('.bunk-pdp__sbname')||{}).textContent || '';
        var pr = priceEl ? priceEl.textContent : '';
        var adds = root.querySelectorAll('[data-pdp-add]');
        adds.forEach(function(b){ b.disabled = true; });
        window.BunkCart.add(vid, 1, { name: nm, price: pr })
          .catch(function(){ try { pdpForm.submit(); } catch(_){} })   // fall back so the user still reaches the cart
          .then(function(){ adds.forEach(function(b){ b.disabled = false; }); });
      });
    }

    /* ── drawer ── */
    var drawer = root.querySelector('[data-pdp-drawer]');
    var scrim  = root.querySelector('[data-pdp-drawer-close]');
    function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } root.querySelectorAll('.bunk-pdp__scrim').forEach(function(s){s.classList.add('is-open');}); }
    function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } root.querySelectorAll('.bunk-pdp__scrim').forEach(function(s){s.classList.remove('is-open');}); }
    root.querySelectorAll('[data-pdp-drawer-open]').forEach(function(b){ b.addEventListener('click', openDrawer); });
    root.querySelectorAll('[data-pdp-drawer-close]').forEach(function(b){ b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeDrawer(); });

    /* ── 21+ age gate ── */
    var gate = root.querySelector('[data-pdp-agegate]');
    try{ if(sessionStorage.getItem('bunk21') && gate) gate.classList.add('is-hide'); }catch(e){}
    var yes = root.querySelector('[data-pdp-age-yes]');
    var no  = root.querySelector('[data-pdp-age-no]');
    if(yes) yes.addEventListener('click', function(){ if(gate) gate.classList.add('is-hide'); try{ sessionStorage.setItem('bunk21','1'); }catch(e){} });
    if(no)  no.addEventListener('click', function(){ window.location.href='https://www.google.com'; });

    // init mood from the selected pill
    var onPill = root.querySelector('[data-pdp-pick].is-on');
    if(onPill && onPill.dataset.mood) setMood(onPill.dataset.mood);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-proof"] && !Shopify.designMode) return;
  try {
    
// bunk-proof — minimal JS
// No carousel, no accordion. The only optional interaction: keyboard-accessible
// COA link open (handled natively by <a> + target="_blank").
// Respects prefers-reduced-motion via bunk-base.css global rule.
(function() {
  'use strict';

  // Receipt tilt: mild parallax-on-scroll for receipts (desktop only, reduced-motion safe)
  var mq = window.matchMedia('(prefers-reduced-motion: no-preference)');
  if (!mq.matches) return;

  var section = document.querySelector('.bunk-proof');
  if (!section) return;

  var receipts = section.querySelectorAll('.bp-receipt');
  if (!receipts.length) return;

  // Subtle lift on scroll — only runs once IntersectionObserver fires
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('bp-receipt--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  receipts.forEach(function(r) { observer.observe(r); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-samplers"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-bunk-samplers]').forEach(function(root){
    var cb=root.querySelector('[data-bs-consent]');
    var btn=root.querySelector('[data-bs-capsubmit]');
    if(cb&&btn){
      var sync=function(){ btn.disabled=!cb.checked; };
      cb.addEventListener('change',sync); sync();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bunk-story"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function initStory(root){
    if(!root || root._bsInit) return; root._bsInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* ---- carousels ---- */
    root.querySelectorAll('[data-bs-carousel]').forEach(function(car){
      var track = car.querySelector('[data-bs-track]');
      var dotsC = car.querySelector('[data-bs-dots]');
      var prev = car.querySelector('[data-bs-prev]');
      var next = car.querySelector('[data-bs-next]');
      var autob = car.querySelector('[data-bs-auto]');
      var autoMode = (car.getAttribute('data-auto') !== 'false' && !reduce);
      var iv = null, vis = false, st = null;
      function slides(){ return Array.prototype.slice.call(track.querySelectorAll(':scope > .bs-cslide')); }
      function idx(){ return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
      function go(i){ var n = slides().length; i = Math.max(0, Math.min(i, n-1)); track.scrollTo({ left: i*track.clientWidth, behavior:'smooth' }); }
      function sync(){ var i = idx(); dotsC.querySelectorAll('.bs-cdot').forEach(function(d,j){ var on = j===i; d.classList.toggle('is-on', on); d.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
      function tick(){ var n = slides().length; if(n<2) return; var i = idx()+1; if(i>=n) i=0; go(i); }
      /* 7000 -> 5000: one shared clock across hero / format / moods / story (Sid 25 Jul, "same as the hero") */
      function runAuto(){ if(!autoMode || !vis) return; clearInterval(iv); iv = setInterval(tick, 5000); }
      function haltAuto(){ clearInterval(iv); iv = null; }
      function killAuto(){ autoMode = false; haltAuto(); if(autob) autob.textContent = '▶'; }
      function buildDots(){
        var ss = slides(), solo = ss.length < 2;
        [prev,next,autob].forEach(function(b){ if(b) b.classList.toggle('is-gone', solo); });
        dotsC.style.display = solo ? 'none' : 'flex';
        dotsC.innerHTML = '';
        if(solo){ haltAuto(); return; }
        ss.forEach(function(s,i){ var d = document.createElement('button'); d.type='button'; d.className='bs-cdot'; d.setAttribute('role','tab'); d.setAttribute('aria-label','go to photo '+(i+1)); d.onclick = function(){ killAuto(); go(i); }; dotsC.appendChild(d); });
        sync();
      }
      track.addEventListener('scroll', function(){ clearTimeout(st); st = setTimeout(sync, 60); }, { passive:true });
      if(prev) prev.onclick = function(){ killAuto(); go(idx()-1); };
      if(next) next.onclick = function(){ killAuto(); go(idx()+1); };
      if(autob) autob.onclick = function(){ autoMode = !autoMode; autob.textContent = autoMode ? '⏸' : '▶'; autoMode ? runAuto() : haltAuto(); };
      ['touchstart','pointerdown','wheel'].forEach(function(ev){ track.addEventListener(ev, killAuto, { passive:true }); });
      car.addEventListener('mouseenter', haltAuto);
      car.addEventListener('mouseleave', runAuto);
      car.addEventListener('focusin', haltAuto);
      car.addEventListener('focusout', runAuto);
      if(autob) autob.textContent = autoMode ? '⏸' : '▶';
      buildDots();
      /* auto-advance ONLY while on screen — don't churn off-screen or slide the hero away before you arrive */
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ vis = e.isIntersecting; e.isIntersecting ? runAuto() : haltAuto(); }); }, { threshold:.55 }).observe(car);
      } else { vis = true; }
      /* boot fallback (IO first callback can lag in embedded webviews) */
      var r = car.getBoundingClientRect();
      if(r.top < innerHeight*0.6 && r.bottom > innerHeight*0.4){ vis = true; if(autoMode && slides().length>1) runAuto(); }
    });

    /* chapter nav lives in the SITE menu (links to #story-beat-N); the beats' scroll-margin-top
       handles the header offset for those anchor jumps — no in-section drawer JS needed. */

    /* ---- sampler capture: gate submit on the 21+/consent checkbox ---- */
    root.querySelectorAll('[data-bs-capform]').forEach(function(f){
      var c = f.querySelector('[data-bs-consent]'); var s = f.querySelector('[data-bs-capsubmit]');
      if(c && s){ var upd = function(){ s.disabled = !c.checked; }; c.addEventListener('change', upd); upd(); }
    });
  }
  document.querySelectorAll('[data-bunk-story]').forEach(initStory);
  document.addEventListener('shopify:section:load', function(e){ var s = e.target.querySelector('[data-bunk-story]'); if(s){ s._bsInit = false; initStory(s); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
